import { graphql } from "gatsby";
import React from "react";
import Leap from "../../../components/Leap";
import SEO from "../../../components/HeadWrapper";

export default function about({ data }: { data: any }) {
  return <Leap data={data?.allFile} />;
}

export const query = graphql`
  query LeapQuery {
    allFile(filter: { relativePath: { regex: "/leap/" } }) {
      edges {
        node {
          id
          publicURL
          name
        }
      }
    }
  }
`;

export const Head = (props: any) => {
  const language = props?.params?.code === 'en' ? 'en' : 'ar';
  return (
    <SEO language={language} pathname={props?.location?.pathname} />
  )
}
